export default {

    async reset({ state, commit }, payload = { force: false }) {
        if (payload.force) {
            return commit('reset')
        }
    },

    async transfer({ commit, rootState, dispatch, state, rootGetters }, payload) {
        let results = { ok: false }
        try {
            let transfered = rootGetters['v4/track/transfers']
            commit('set', { transfered: transfered, applied: false })

        }
        catch (e) {
            console.log(e)
        }
        results = { ok: true }
        return results

    },

    async parse({ commit, rootState, dispatch, state, rootGetters }, payload) {
        let results = { ok: false }

        try {
            let fhir = await dispatch('v4/xsz/base64urlDecode', payload, { root: true })

            if (!fhir.ok) { throw new Error('Could not decode FHIR bundle') }
            commit('set', { fhir: JSON.parse(fhir.data) })

            let observations = await dispatch('v4/mrx/parseFHIRObservations', state.fhir, { root: true })

            if (observations.rejected.length > 0) {
                console.log('Rejected Observations')
                console.log(observations.rejected)
            }

            commit('set', { accepted: observations.accepted, rejected: observations.rejected, applied: false })

            if (rootGetters['v4/track/active']) {
                await dispatch('apply')
            }

            results = { ok: true }

        }
        catch (e) {}

        return results
    },


    async apply({ state, dispatch, getters, commit, rootState, rootGetters }) {
        let results = { ok: false }
        try {
            let track = rootGetters['v4/track/current']
            let panels = track.panels
            let all = [].concat(state.accepted, state.transfered)
            all.forEach(observation => {
                let existingPanel = panels.find(panel => panel.name === observation.name)
                if (existingPanel) {

                    let options = { prefilled: true, disabled: observation.disabled }
                    Object.assign(existingPanel.options, options)

                    if (existingPanel.type === 'value' && !existingPanel.responses[0].selected) {
                        existingPanel.responses[0].value = observation.value
                        existingPanel.responses[0].selected = true
                    }

                    else if (existingPanel.type === 'select' && !existingPanel.responses.some(x => x.selected)) {
                        existingPanel.responses.forEach(response => {
                            if (response.value === observation.value) { response.selected = true }
                        })
                    }

                }
            })
            commit('set', { applied: true })
            results = { ok: true }
        }
        catch (e) {}
        return results
    },

}
